import React, { FunctionComponent, useEffect, useState } from 'react';

import { Card, Stack, Typography } from '@mui/material';
import { PurchaseDto } from '../../dto/PurchaseDto';
import Anat from '../../image/Anatomy.svg';
import Hist from '../../image/Gistology.svg';
import Bioc from '../../image/Biochemistry.svg';
import Phys from '../../image/Physiology.svg';
import Tick from '../../image/TickNew.svg';
import TickSelect from '../../image/Tick_1New.svg';
import classes from './PurchaseDiv.module.css';
import Anat1 from '../../image/webp_Anatomy-Constructor.webp';
import Hist1 from '../../image/webp_Gistology-Constructor.webp';
import Bioc1 from '../../image/webp_Biochemistry-Constructor.webp';
import Phys1 from '../../image/webp_Physiology-Constructor.webp';

interface Props {
  onClick: (e: any) => void;
  isSelect: boolean;
  discount: number;
  variant: number;
  dto?: PurchaseDto;
}

export const PutchaseDivItem: FunctionComponent<Props> = ({
  onClick,
  isSelect,
  discount,
  variant,
  dto,
}) => {
  const [startAnimation, setSatrtAnimation] = useState(false);
  const getImage = (route: string) => {
    if (route === 'anatomy') {
      return Anat;
    }
    if (route === 'histology') {
      return Hist;
    }
    if (route === 'biochemistry') {
      return Bioc;
    }
    if (route === 'physiology') {
      return Phys;
    }
    return '';
  };

  const getImage2 = (route: string) => {
    if (route === 'anatomy') {
      return Anat1;
    }
    if (route === 'histology') {
      return Hist1;
    }
    if (route === 'biochemistry') {
      return Bioc1;
    }
    if (route === 'physiology') {
      return Phys1;
    }
    return '';
  };

  const getWidth = (route: string) => {
    if (route === 'anatomy') {
      return '149px';
    }
    if (route === 'histology') {
      return '90px';
    }
    if (route === 'biochemistry') {
      return '90px';
    }
    if (route === 'physiology') {
      return '90px';
    }
    return '';
  };

  useEffect(() => {
    setSatrtAnimation(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [discount]);

  return (
    <Stack
      width="335px"
      height="76px"
      alignItems="center"
      direction="row"
      sx={{
        borderRadius: '24px',
        filter: 'drop-shadow(0 0 12px #FFFFFF33)',
        background: isSelect ? '#00C7D3' : '#FFFFFF33',
      }}
    >
      {isSelect && (
        <Typography
          width="40px"
          fontWeight={700}
          fontFamily="Roboto"
          lineHeight="20px"
          fontSize="12px"
          letterSpacing="0.21px"
          textAlign="right"
          color="#FFFFFF"
          component="text"
          position="absolute"
          onAnimationEnd={() => setSatrtAnimation(false)}
          className={startAnimation ? classes.divShake : ''}
        >
          -{discount}%
        </Typography>
      )}
      <Card
        sx={{
          marginLeft: '2px',
          transform: isSelect ? 'translate(46px)' : undefined,
          transition: 'transform 0.1s ease-out',
          width: '285px',
          borderRadius: '22px',
        }}
        onClick={onClick}
      >
        <Stack
          height="72px"
          width="100%"
          style={{
            backgroundImage: `url(${getImage2(dto?.route ?? '')})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'left center',
            backgroundSize: `${getWidth(dto?.route ?? '')} 72px`,
          }}
          direction="row"
          alignItems="center"
        >
          <Stack direction="row" justifyContent="right" width="85%">
            <Stack direction="row" alignItems="center" spacing={1}>
              <Stack alignItems="end" spacing={0.2}>
                <Typography
                  fontWeight={400}
                  fontFamily="Roboto"
                  lineHeight="100%"
                  fontSize="12px"
                  letterSpacing="0.21px"
                  textAlign="center"
                  color="#00000080"
                  component="text"
                >
                  {' '}
                </Typography>
                <Typography
                  fontWeight={700}
                  fontFamily="Comfortaa"
                  lineHeight="100%"
                  fontSize="14px"
                  letterSpacing="0.21px"
                  textAlign="center"
                  color="#000000"
                  component="text"
                >
                  {dto?.name}
                </Typography>
                <Typography
                  fontWeight={400}
                  fontFamily="Roboto"
                  lineHeight="100%"
                  fontSize="12px"
                  letterSpacing="0.21px"
                  textAlign="center"
                  color="#00000080"
                  component="text"
                >
                  {dto?.subtitle}
                </Typography>
              </Stack>
              <Stack
                direction="row"
                paddingRight="10px"
                alignItems="center"
                spacing={2}
              >
                <img
                  alt=""
                  width="32px"
                  height="32px"
                  src={getImage(dto?.route ?? '')}
                  style={{ cursor: 'pointer' }}
                />
              </Stack>
            </Stack>
          </Stack>
          <Stack
            width="60px"
            height="72px"
            alignItems="center"
            justifyContent="center"
          >
            <img alt="" src={isSelect ? TickSelect : Tick} />
          </Stack>
        </Stack>
      </Card>
      {!isSelect && variant === 0 && (
        <Stack direction="column" spacing={0}>
          <Typography
            width="40px"
            fontWeight={700}
            fontFamily="Roboto"
            lineHeight="100%"
            fontSize="12px"
            letterSpacing="0.21px"
            textAlign="right"
            color="#FFFFFF80"
            component="text"
            position="relative"
          >
            {dto?.cenaMonth} ₽
          </Typography>
          <Typography
            fontWeight={400}
            fontFamily="Roboto"
            lineHeight="100%"
            fontSize="10px"
            letterSpacing="0.21px"
            textAlign="center"
            color="#FFFFFF80"
            component="text"
          >
            мес
          </Typography>
        </Stack>
      )}
    </Stack>
  );
};

PutchaseDivItem.defaultProps = {
  dto: undefined,
};
